// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2r-sV","heading":"lqp0S","subText":"_3kRdU"};